import { EWsStatus } from 'src/app/shared/enums/websocket-status.enum';

function connectHandler(
  send: (p: any) => void,
  idBooking: number,
  loggedInEntityId: number,
  entityId: number | string,
  loggedInEntity: string,
  entity: string
) {
  this.config.ws.connected = true;

  send({ action: EWsStatus.NEW_CONNECTION, metadata: { idBooking, loggedInEntityId, entityId, loggedInEntity, entity } });
}

export default connectHandler;
